export const refundTable = {
  header: 'All Refunds',
  id: 'Refund ID',
  status: 'Status',
  amount: 'Amount',
  fee: 'Fee',
  reason: 'Reason',
  transactionId: 'Transaction ID',
  date: 'Date',
  search: 'Search refunds',
  orderId: 'Order ID',
  title: 'Refunds',
};

export const rowActions = {
  view: 'View Refund Details',
  sendReceipt: 'Send Receipt',
};
